import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { Table, Form, InputGroup, Button, Badge, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faEdit,
  faTrash,
  faCheckCircle,
  faTimesCircle,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import "../Admin/AdminDashboard.css";
import MyContext from "../../MyContext";
import refreshicon from "../../images/refresh-2.svg"

const WhitelistedClientsTable = ({ Admin }) => {
  const { baseUrl, config } = useContext(MyContext);
  const [clients, setClients] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (err) => toast.error(err.message)
      );
    }
    fetchClients();
  }, []);

  const fetchClients = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}/api/SuperAdmin/getWhiteListedAudience`,
        { userid: Admin.pkid, latitude, longitude },
        config
      );
      if (response.data.responseCode === "00") {
        setClients(response.data.response);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Error fetching clients");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const addClient = async () => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/SuperAdmin/addWhiteListedAudience`,
        { userid: Admin.pkid, mobile, name },
        config
      );
      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        fetchClients();
        setShowModal(false);
      } else {
        toast.error(response.data.responseMessage);
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error(error);
    }
  };

  const deleteClient = async (id) => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${baseUrl}/api/SuperAdmin/removeWhiteListedAudience`,
        { userid: Admin.pkid, audienceId: id },
        config
      );
      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        fetchClients();
      }
    } catch (error) {
      toast.error("Error deleting client");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const filteredClients = clients.filter((client) =>
    Object.values(client).some((value) =>
      value?.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  return (
    <div className=" marginRight">
      <div className="profile-section-whatsapp d-flex justify-content-between">
        <div className=" d-flex align-items-center">
          <faCheckCircle size={46} className="me-2" />
          <h1 className="text-muted">Whitelisted</h1>
        </div>
        <div> <Button variant="light" className="me-1 border"onClick={() => fetchClients()}>
        <img className="me-1" src={refreshicon} alt="Refresh" />Refresh
        </Button>
        <Button variant="primary" onClick={() => setShowModal(true)}>
          Add Whitelist
        </Button></div>
       
      </div>
      <div className="p-4">
        {" "}
        <InputGroup className="mb-3">
          <InputGroup.Text>
            <FontAwesomeIcon icon={faSearch} />
          </InputGroup.Text>
          <Form.Control
            placeholder="Search clients..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </InputGroup>
        <Table responsive striped bordered hover>
          <thead>
            <tr>
              <th>ID</th>
              <th>Code</th>
              <th>User Name</th>
              <th>Name</th>
              <th>Mobile</th>
              <th>Status</th>
              <th>Whitelisted On</th>

              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredClients? filteredClients.map((client) => (
              <tr key={client.id}>
                <td>{client.id}</td>
                <td>{client.user_code}</td>
                <td>{client.user_name}</td>
                <td>{client.name}</td>
                <td>{client.mobile_number}</td>
                <td>
                  <Badge bg={client.status === "Y" ? "success" : "danger"}>
                    <FontAwesomeIcon
                      icon={
                        client.status === "Y" ? faCheckCircle : faTimesCircle
                      }
                    />
                    {client.status === "Y" ? "Active" : "Inactive"}
                  </Badge>
                </td>
                <td>{client.created_on}</td>

                <td>
                  {/* <Button variant="outline-primary" size="sm" className="me-2">
                    <FontAwesomeIcon icon={faEdit} /> Edit
                  </Button> */}
                  <Button
                    variant="outline-danger"
                    size="sm"
                    className="me-2"
                    onClick={() => deleteClient(client.id)}
                  >
                    <FontAwesomeIcon icon={faTrash} /> Delete
                  </Button>
                  {/* <Button variant="outline-success" size="sm" onClick={() => deleteClient(client.id)}>
                  <FontAwesomeIcon icon={faPlus} /> Top Up
                </Button> */}
                </td>
              </tr>
            )): loading?<div class="spinner-border text-success" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>:""}
           
          </tbody>
        </Table>
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Mobile</Form.Label>
              <Form.Control
                type="text"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button variant="success" onClick={addClient}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default WhitelistedClientsTable;
